<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
  >
    <path d="M15.25 0.75C15.6642 0.75 16 1.08579 16 1.5V12.5C16 12.9142 15.6642 13.25 15.25 13.25C14.8358 13.25 14.5 12.9142 14.5 12.5V1.5C14.5 1.08579 14.8358 0.75 15.25 0.75ZM0 7C0 6.58579 0.335786 6.25 0.75 6.25H10.9393L8.21967 3.53033C7.92678 3.23744 7.92678 2.76256 8.21967 2.46967C8.51256 2.17678 8.98744 2.17678 9.28033 2.46967L13.277 6.46634C13.2891 6.47836 13.3009 6.49079 13.3122 6.50361C13.3626 6.56051 13.4028 6.62323 13.4329 6.68943C13.476 6.78406 13.5 6.88923 13.5 7C13.5 7.11223 13.4753 7.2187 13.4312 7.3143C13.4019 7.37778 13.3633 7.438 13.3153 7.4929C13.3029 7.50709 13.29 7.5208 13.2766 7.53401L9.28033 11.5303C8.98744 11.8232 8.51256 11.8232 8.21967 11.5303C7.92678 11.2374 7.92678 10.7626 8.21967 10.4697L10.9393 7.75H0.75C0.335786 7.75 0 7.41421 0 7Z" />
  </svg>
</template>
